export default "__VITE_ASSET__DT00DtVl__"